import Vue from 'vue'
import Vuex from 'vuex'

/*import persistedState from 'vuex-persistedstate'    //持久存储插件
import Cookies from 'js-cookie'*/

Vue.use(Vuex);


export default new Vuex.Store({
	state: {
		baseUrl: "http://test-health.vita-course.com",
		// baseUrl: "http://192.168.31.97:8082",
		// baseUrl:"https://health.vita-course.com",  
		isMobileDebug: false, // 是否开启移动端调试插件

		vtoken: '',
		// 转换时间，请求接口时使用
		switchTime: {
			"日": "hour", // day
			"周": "week",
			"月": "month",
			"年": "year"
		},
		week: {
			1: '周一',
			2: '周二',
			3: '周三',
			4: '周四',
			5: '周五',
			6: '周六',
			7: '周日',
		},
		// weekStr: {
		// 	1: this.$t('common.monday'),
		// 	2:this.$t('common.tuesday'),
		// 	3: this.$t('common.wednesday'),
		// 	4: this.$t('common.thursday'),
		// 	5: this.$t('common.friday'),
		// 	6: this.$t('common.saturday'),
		// 	7: this.$t('common.sunday'),
		// },
		// x轴标量类型，绘图中使用
		xAxisType: {
			'日': 24, // 24小时
			'周': 7, // 7天
			'月': 30, // 30天，动态变化的
			'年': 12 // 12个月
		},

	},
	getters: {

	},
	mutations: {

	},
	actions: {

	},
	//plugins: [persistedState()],
	/*plugins: [persistedState({
	    //storage: window.sessionStorage,


	    //使用cookie保存state
	    storage: {
	        getItem: key => Cookies.get(key),
	        setItem: (key, value) => Cookies.set(key, value, {
	            expires: 7,    //cookie保存7天
	            //expires: new Date(new Date().getTime() +5 * 1000),   //cookie保存5秒
	        }),
	        removeItem: key => Cookies.remove(key)
	    },


	    //指定cook.js模块进行持久化
	    /!*reducer(val) {
	        return {    cookie: val.cookie    };
	    }*!/
	})]*/

})
